/* eslint-disable react/display-name */
import { Button, Popover, Space, Table, TableProps, Tag, Typography } from 'antd';
import React, { useMemo } from 'react';
import ConfirmButton from 'src/components/atoms/ConfirmButton';
import HeadsetWorkingMode from 'src/components/atoms/HeadsetWorkingMode';
import { RoleEnum } from 'src/features/users/users.types';
import ComponentRoleProtected from 'src/components/blocks/ComponentRoleProtected';
import { GroupDevice } from 'src/features/deviceGroups/deviceGroups.types';

export interface DevicesTableProps {
  devices: GroupDevice[];
  className?: string;
  loading?: boolean;
  style?: React.CSSProperties;
  addMode: boolean;
  onRemove: (device: GroupDevice) => void;
  onAdd: (device: GroupDevice) => void;
}

const DevicesTable: React.FC<DevicesTableProps> = props => {
  const { devices, loading, onRemove, addMode, onAdd } = props;

  const tableConfig = useMemo<TableProps<GroupDevice>>(() => {
    const result: TableProps<GroupDevice> = {
      dataSource: devices,
      rowKey: values => values.id,
      columns: [
        {
          title: 'Метка шлема',
          dataIndex: 'label',
          key: 'label',
          render: (label: string, headset) => (
            <Space direction={'horizontal'} style={{ justifyContent: 'space-between', width: '100%' }}>
              <Space direction={'vertical'} size={2}>
                <Space direction={'horizontal'} size={5}>
                  <Popover content={`ID Шлема: ${headset.phyDeviceId}`}>
                    <div>
                      <span style={{ textTransform: 'uppercase' }}>{label || '-'}</span>{' '}
                    </div>
                  </Popover>
                  {addMode && headset.deviceGroupId && <Tag color={'orange'}>Группа: {headset.deviceGroupName}</Tag>}
                </Space>
                <Space>{headset.companyName}</Space>
              </Space>
              <Space direction={'horizontal'}>{headset.isTest && <Tag color='blue'>Тестовый</Tag>}</Space>
            </Space>
          ),
        },
        {
          title: 'Комната',
          dataIndex: 'roomLabel',
          key: 'roomLabel',
          align: 'right',
          width: 100,
          render: value => <Typography.Text style={{ textTransform: 'uppercase' }}>{value || '-'}</Typography.Text>,
        },
        {
          title: 'Режим работы',
          dataIndex: 'workingMode',
          key: 'workingMode',
          align: 'right',
          width: 120,
          render: workingMode => <HeadsetWorkingMode workingMode={workingMode} />,
        },
        {
          title: 'Действия',
          dataIndex: 'actions',
          key: 'actions',
          align: 'right',
          render: (value, device) => (
            <ComponentRoleProtected roles={[RoleEnum.admin]}>
              {addMode ? (
                <Button type={'primary'} onClick={() => onAdd(device)}>
                  Добавить
                </Button>
              ) : (
                <ConfirmButton danger onClick={() => onRemove(device)}>
                  Удалить
                </ConfirmButton>
              )}
            </ComponentRoleProtected>
          ),
        },
      ],
    };
    return result;
  }, [addMode, devices, onAdd, onRemove]);

  return <Table {...tableConfig} size='middle' pagination={{ pageSize: 50 }} loading={loading} />;
};

export default DevicesTable;
